import { Modal } from '@morressier/alembic';
import TemplateVariablesList from '../TemplateVariablesList';
import { Flex, Text } from '@chakra-ui/react';

interface Props {
  onClose: () => void;
}

const ViewVariables = ({ onClose }: Props) => {
  return (
    <Modal isOpen={true} onClose={onClose} width="540px">
      <Flex flexDirection="column" padding={4}>
        <Text textStyle="headingGroup">Personalized Variables</Text>
        <Text textStyle="headingOverline">
          Personalize your email using the variables provided.
        </Text>
      </Flex>
      <Flex padding={4} flexDirection="column">
        <TemplateVariablesList onCopy={onClose} />
      </Flex>
    </Modal>
  );
};

export default ViewVariables;
